import React from 'react'
import classNames from 'classnames'
import { ButtonGroupsProps } from './types'
import styles from './styles.module.scss'

export const ButtonGroups: React.FC<ButtonGroupsProps> = ({
  items,
  onClickLockedItem
}) => {
  return (
    <span
      className={styles.buttonGroups}
      id="button-groups"
      aria-label="button-groups"
    >
      {items.map((item, index) => (
        <button
          key={item.name}
          type="button"
          className={classNames(styles.button, {
            [styles.first]: index === 0,
            [styles.last]: index === items.length - 1,
            [styles.middle]: index > 0 && index < items.length - 1,
            [styles.selected]: item.active,
            [styles.disabled]: item.disabled || item.locked
          })}
          onClick={item.locked ? onClickLockedItem : item.onClick}
        >
          {item.name}
        </button>
      ))}
    </span>
  )
}
